import { Plugin } from "@ckeditor/ckeditor5-core";
import {
  createDropdown,
  addListToDropdown,
} from "@ckeditor/ckeditor5-ui/src/dropdown/utils";
import { UIModel as Model } from "@ckeditor/ckeditor5-ui";
import { Collection } from "@ckeditor/ckeditor5-utils";

import InsertInteractionIcon from "./playlist-plus.svg";
import interactionTypes from "./interactionTypes.json";

export default class InteractionUI extends Plugin {
  init() {
    const editor = this.editor;
    const t = editor.t;

    editor.ui.componentFactory.add("createInteraction", (locale) => {
      const command = editor.commands.get("createInteraction");
      const dropdownView = createDropdown(locale);

      dropdownView.buttonView.set({
        icon: InsertInteractionIcon,
        isOn: false,
        label: t("Create Interaction"),
        tooltip: true,
      });

      const options = new Collection();

      interactionTypes
        .filter(({ active }) => active)
        .map(({ label }) => {
          options.add({
            type: "button",
            model: new Model({
              label,
              withText: true,
            }),
          });
        });

      addListToDropdown(dropdownView, options);

      dropdownView.bind("isEnabled").to(command);
      dropdownView.on("execute", (e) => {
        const { label } = e.source;
        command.execute({ label });
      });
      return dropdownView;
    });
  }
}
